import styled from 'styled-components'
import { tokens } from '../../styles/tokens'

// ─── Styled pieces ────────────────────────────────────────
export const TableWrapper = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid ${tokens.purple100};
  overflow: hidden;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const THead = styled.thead`
  background: ${tokens.purple50};
  border-bottom: 1px solid ${tokens.purple100};
`

export const TH = styled.th`
  padding: 11px 16px;
  text-align: left;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${tokens.purple400};
`

export const TR = styled.tr`
  border-bottom: 1px solid ${tokens.purple100};
  transition: background 0.1s;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: ${tokens.purple50};
  }
`

export const TD = styled.td`
  padding: 14px 16px;
  font-size: 13px;
  color: ${tokens.purple900};
  vertical-align: middle;
`

export const ActionsCell = styled(TD)`
  width: 100px;
  text-align: right;
`

// ─── Empty state ──────────────────────────────────────────
const EmptyWrapper = styled.div`
  padding: 48px;
  text-align: center;
`

const EmptyTitle = styled.p`
  font-family: 'Cormorant Garamond', serif;
  font-size: 20px;
  color: ${tokens.purple200};
  margin-bottom: 6px;
`

const EmptySub = styled.p`
  font-size: 12px;
  color: ${tokens.purple200};
`

export function EmptyState({ message = 'No records found' }: { message?: string }) {
  return (
    <EmptyWrapper>
      <EmptyTitle>Nothing here yet</EmptyTitle>
      <EmptySub>{message}</EmptySub>
    </EmptyWrapper>
  )
}

// ─── Page header ──────────────────────────────────────────
export const PageHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 24px;
`

export const PageMeta = styled.div``

export const PageEyebrow = styled.p`
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${tokens.purple400};
  margin-bottom: 6px;
`

export const PageTitle = styled.h1`
  font-family: 'Cormorant Garamond', serif;
  font-size: 36px;
  font-weight: 300;
  color: ${tokens.purple900};
  letter-spacing: -0.5px;
`

export function TableSkeleton({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <TableWrapper>
      <StyledTable>
        <THead>
          <tr>
            {Array.from({ length: cols }, (_h, colIndex) => (
              <TH key={`th-${colIndex}`}>&nbsp;</TH>
            ))}
          </tr>
        </THead>
        <tbody>
          {Array.from({ length: rows }, (_r, rowIndex) => (
            <TR key={`tr-${rowIndex}`}>
              {Array.from({ length: cols }, (_c, colIndex) => (
                <TD key={`td-${rowIndex}-${colIndex}`}>
                  <div
                    style={{
                      height: 14,
                      width: colIndex === cols - 1 ? 60 : '70%',
                      borderRadius: 4,
                      background: tokens.purple100,
                    }}
                  />
                </TD>
              ))}
            </TR>
          ))}
        </tbody>
      </StyledTable>
    </TableWrapper>
  )
}
